import { IIsMobileSetAction } from './types';
import { AT_IS_MOBILE_SET } from './constants';

export const isMobileSetAction = (
    isMobile: boolean
): IIsMobileSetAction => ({
    type: AT_IS_MOBILE_SET,
    isMobile
});
